import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    services: [
      { name: '舊屋改造', path: '/services#old-house' },
      { name: '浴室改造', path: '/services#bathroom' },
      { name: '室內裝修統包', path: '/services#turnkey' },
      { name: '居家軟裝設計', path: '/services#soft-decoration' },
      { name: '出租裝修服務', path: '/services#rental' },
    ],
    portfolio: [
      { name: '舊屋改造案例', path: '/portfolio#old-house' },
      { name: '浴室改造案例', path: '/portfolio#bathroom' },
      { name: '小宅改造案例', path: '/portfolio#small-house' },
    ],
    about: [
      { name: '關於我們', path: '/#about' },
      { name: '服務流程', path: '/#process' },
      { name: '常見問題', path: '/#faq' },
    ],
    contact: [
      { name: 'LINE諮詢', path: 'https://lin.ee/JAWndnI', external: true },
      { name: '預約評估', path: 'https://go.hotcake.app/g/VB3HEP', external: true },
    ],
  };

  return (
    <footer className="bg-[#0A1F38] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <h4 className="text-base font-bold mb-4">服務項目</h4>
            <div className="w-10 h-0.5 bg-[#4A90C2] mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.path}
                    className="text-sm text-[#94A3B8] hover:text-[#4A90C2] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">作品案例</h4>
            <div className="w-10 h-0.5 bg-[#4A90C2] mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.portfolio.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.path}
                    className="text-sm text-[#94A3B8] hover:text-[#4A90C2] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">關於我們</h4>
            <div className="w-10 h-0.5 bg-[#4A90C2] mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.path}
                    className="text-sm text-[#94A3B8] hover:text-[#4A90C2] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">聯絡方式</h4>
            <div className="w-10 h-0.5 bg-[#4A90C2] mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.contact.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.path}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="text-sm text-[#94A3B8] hover:text-[#4A90C2] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-baseline gap-4">
            <span className="text-6xl font-black font-serif">GELi 閣立</span>
            <div className="flex flex-col">
              <span className="text-xl text-[#94A3B8]">閣立室內裝修</span>
              <div className="w-20 h-px bg-[#4A90C2] mt-2 mb-1"></div>
              <span className="text-xs text-[#94A3B8]">讓裝修成為生活的開始</span>
            </div>
          </div>

          <div className="flex flex-col items-end gap-4">
            <div className="flex items-center gap-4">
              <a
                href="https://lin.ee/JAWndnI"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#1E4D7B] flex items-center justify-center text-white hover:bg-[#4A90C2] transition-colors cursor-pointer"
              >
                <i className="ri-line-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#1E4D7B] flex items-center justify-center text-white hover:bg-[#4A90C2] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#1E4D7B] flex items-center justify-center text-white hover:bg-[#4A90C2] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
            <p className="text-xs text-[#94A3B8]">
              © 2025 GELi 閣立室內裝修。版權所有。 | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#4A90C2] transition-colors">Website Builder</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
